var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("Headline", { attrs: { styling: "page-title", level: 2 } }, [
        _vm._v("Die Corps der Garde"),
      ]),
      _c("Separator"),
      _c(
        "div",
        { staticClass: "corps" },
        [
          _c("TopicHeader", {
            attrs: { id: "piccolos", src: _vm.piccolos, title: "Die Piccolos" },
          }),
          _c("Paragraph", [
            _vm._v(
              " Den Piccolotanz üben die Kinder mit Hilfe ihrer Piccolobetreuung ein. Hierbei ist es der Garde besonders wichtig, dass die Kinder auch Kind sein dürfen. Perfektion liegt dem Piccolocorps fern. Diese liegt eher in der Spontanität und ihr ist Genüge getan, wenn die Kleinen mit Ende der Musik ihren Tanz vollendet haben. Mit 14 Jahren haben die Piccolos dann ausreichende „Flaschenreifung“ genossen, um voller Tatendrang in ihr Gardeleben als aktives Mariechen oder aktiver Gardist der Ehrengarde durchzustarten. "
            ),
          ]),
          _c("Picture", { attrs: { src: _vm.freizeitPicccolo } }),
          _c("Paragraph", [
            _vm._v(
              " Neben dem Karneval und der Historie gibt es auch viele andere Aktionen, welche innerhalb der Garde stattfinden wie beispielsweise hier auf dem Foto zusehen der Bau eines Insektenhotels während des all jährlichen Pfingstzeltlager. Wenn Du mitmachen möchtest, sprich uns doch einfach bei einem unserer Auftritte an, schau bei den Proben vorbei oder wende dich an die Piccolobetreuung. "
            ),
          ]),
          _c("Contacts", {
            attrs: {
              contacts: [
                {
                  position: "",
                  name: "Piccolobetreuung",
                  email: "kontakt-piccolos@ehrengarde-neuwied.de",
                },
              ],
            },
          }),
          _c("Separator"),
          _c("TopicHeader", {
            attrs: { id: "aktive", src: _vm.garde, title: "Die aktive Garde" },
          }),
          _c("Paragraph", [
            _vm._v(
              " Manch einer denkt wohl, dass es sich beim „Aktiven Corps“ um die jungen Wilden des Vereins handelt. Weit gefehlt. Denn die Zugehörigkeit zum Aktiven Corps richtet sich weniger nach dem Alter, sondern vielmehr nach dem Grad der Aktivität. Wer also etwas mehr Zeit investieren möchte, ist hier genau richtig. Ob beim eifrigen Tanzbein schwingen im Gardetanz oder bei Serviceeinsätzen wie z. B. beim Sommerfest des Festausschusses, dem Deichstadtfest oder im Heerlager bei den Markttagen – das Aktive Corps ist immer im Einsatz. Wenn Du mitmachen möchtest, sprich uns doch einfach bei einem unserer Auftritte an, schau bei den Proben vorbei oder schreib uns, wir freuen uns auf jedes neue Gesicht. "
            ),
          ]),
          _c("Separator"),
          _c("TopicHeader", {
            attrs: {
              id: "reservisten",
              src: _vm.reservisten,
              title: "Die Reservisten",
            },
          }),
          _c("Paragraph", [
            _vm._v(
              " Von wegen die Reserve hat Ruh… Unsere Reservisten gehören noch lange nicht zum alten Eisen. Ganz im Gegenteil. Sie werden nach wie vor gebraucht und unterstützen den Verein mit Know How, Ideen und oft genug mit helfenden Händen. So manch einer hat sich in den letzten Jahren auch wieder aktiv im Gardetanz als sogenannte „tanzende Reserve“ eingebracht. Die Grenzen verlaufen hier fließend und sind auch für alte Hasen nicht immer leicht zu durchschauen. Wenn Du mitmachen möchtest, sprich uns doch einfach bei einem unserer Auftritte an, schau bei den Proben vorbei oder schreib uns, wir freuen uns auf jedes neue Gesicht. "
            ),
          ]),
          _c("Contacts", {
            attrs: {
              contacts: [
                {
                  image: _vm.gerd,
                  position: "Kommandeur",
                  name: "Gerd Schanz",
                  email: "kontakt-reservisten@ehrengarde-neuwied.de",
                },
              ],
            },
          }),
          _c("Separator"),
          _c("TopicHeader", {
            attrs: {
              id: "eos",
              src: _vm.ehrenoffiziere,
              title: "Die Ehrenoffiziere",
            },
          }),
          _c("Paragraph", [
            _vm._v(
              " Seit 2002 leitet Hans-Wilhelm Schaback das Corps als Kommandeur und ist ein wichtiges Bindeglied zwischen den Ehrenoffizieren und der restlichen Garde und leitet als Mitglied des erweiterten Vorstandes die Geschicke des Vereins mit. Neben der ideellen und finanziellen Unterstützung stellt das Ehrenoffizierscorps bei der Traditionellen Gardesitzung den Elferrat. Aber viele der Ehrenoffiziere tragen auch Uniform und unterstützen die Garde bei ihren verschiedenen Auftritten im Karneval und der Historie. Traditionell werden ein bis zwei Ehrenoffiziere pro Jahr neu ernannt. Die Offiziersrunde schlägt in jedem Jahr verdiente Mitglieder der Garde, verdiente Karnevalisten sowie Persönichkeiten aus Politik und Wirtschaft vor. Über die Vorschläge wird innerhalb des Ehrenoffizierscorps abgestimmt. "
            ),
          ]),
          _c("Contacts", {
            attrs: {
              contacts: [
                {
                  position: "Kommandeur",
                  name: "Hans-Wilhelm Schaback",
                  email: "kontakt-ehrenoffiziere@ehrengarde-neuwied.de",
                },
              ],
            },
          }),
          _c("Separator"),
          _c("SocialMedia"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }